import React, { useEffect, useState } from 'react';
import './../Styles/Admin.css';
import './../Styles/HRDashboard.css';
import axios from 'axios';
import ProfileDialog from './ProfileDialog';
import AppHeader from './AppHeader';
import ReviewedReports from './Reports/ReviewedReports';
import EmployeeDetailsDialog from './EmployeeDetailsDialog';
import AddEmployeeToOrg from './AddEmployeeToOrg';

const apiUrl = process.env.REACT_APP_API_URL;

const HRDashboard = () => {
    const [currentSection, setCurrentSection] = useState('reviewed-reports');
    const [selectedEmployee, setSelectedEmployee] = useState(null);
    const [selectedQuarter, setSelectedQuarter] = useState(null);

    const [hrInfo, setHrInfo] = useState({ full_name: '', job_title: '', employee_number: '' });
    const [isProfileDialogOpen, setProfileDialogOpen] = useState(false);

    useEffect(() => {
        const empId = localStorage.getItem('employeeId');
        if (!empId) return;

        axios.get(`${apiUrl}/api/employee-info/${empId}`)
            .then(response => setHrInfo(response.data))
            .catch(err => console.error('Error fetching HR info:', err));
    }, []);

    const handleOpenProfileDialog = () => setProfileDialogOpen(true);
    const handleCloseProfileDialog = () => setProfileDialogOpen(false);

    return (
        <div className="hr-dashboard-page">
            {/* Top Header */}
            <AppHeader
                title="PERFORMANCE MANAGEMENT"
                employeeInfo={hrInfo}
                onProfileClick={handleOpenProfileDialog}
                hideLogo={false}
            />

            {/* Layout Body: Sidebar + Main Content */}
            <div className="hr-body-wrapper">
                <aside className="hr-sidebar">
                    <nav className="nav-menu">
                        <a
                            href="#"
                            className={`nav-item ${currentSection === 'reviewed-reports' ? 'active' : ''}`}
                            onClick={(e) => { e.preventDefault(); setCurrentSection('reviewed-reports'); }}
                        >
                            Reviewed Reports
                        </a>
                        <a
                            href="#"
                            className={`nav-item ${currentSection === 'add-to-org' ? 'active' : ''}`}
                            onClick={(e) => { e.preventDefault(); setCurrentSection('add-to-org'); }}
                        >
                            Settings
                        </a>
                    </nav>
                </aside>

                <main className="hr-main-content">
                    {currentSection === 'reviewed-reports' && (
                        <div className="reports-section-wrapper">
                            <ReviewedReports
                                onViewDetails={(emp, quarter) => {
                                    setSelectedEmployee(emp);
                                    setSelectedQuarter(quarter);
                                }}
                            />
                        </div>
                    )}

                    {currentSection === 'add-to-org' && (
                        <AddEmployeeToOrg />
                    )}
                </main>
            </div>

            {/* Employee Details Dialog — Same detailed assessment modal as Main Manager (Read-Only) */}
            {selectedEmployee && (
                <EmployeeDetailsDialog
                    employee={selectedEmployee}
                    selectedQuarter={selectedQuarter}
                    reviewerRole="hr"
                    hideLeadComment={true}
                    hideLeadRating={true}
                    readOnly={true}
                    onClose={() => {
                        setSelectedEmployee(null);
                        setSelectedQuarter(null);
                    }}
                />
            )}

            {/* Profile Dialog */}
            {isProfileDialogOpen && (
                <ProfileDialog
                    employeeInfo={hrInfo}
                    onClose={handleCloseProfileDialog}
                    onUpdate={(updatedData) => setHrInfo(prev => ({ ...prev, ...updatedData }))}
                />
            )}
        </div>
    );
};

export default HRDashboard;
